import { GetProjectDetailsArgs, ProjectDetailsResponseDTO } from './project.types';
import { V1Service } from '@hotjar/api-client-engage-insights';

export const getProjectDetails = ({
  participationUuid,
  projectUuid,
}: GetProjectDetailsArgs): Promise<ProjectDetailsResponseDTO> => {
  return V1Service.v1PublicProjectsDetailsRetrieve(projectUuid, participationUuid);
};
